import axios from 'axios';
import Constants, { fixProtocol } from '../../../constants/constants';
import { RestorativeProgram } from './types';

export const addPlayer = async (firstName: string, lastName: string, restorativePrograms: RestorativeProgram[]) => {
  const restorativeProgramIds = restorativePrograms.map((program) => {
    return program.id;
  });

  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/restorative-player`);

  const config = {
    first_name: firstName,
    last_name: lastName,
    restorative_program_ids: restorativeProgramIds,
  };
  try {
    const response = await axios.post(url.toString(), config);
    return response.data.player_id;
  } catch (e) {
    return false;
  }
};
